// main.jsx
import React, { Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import "regenerator-runtime/runtime";
// import 'regenerator-runtime/runtime'
import App from './App.jsx';
import './main.scss';


import { AuthContextProvider } from './context/AuthContext.jsx';
// import { SocketContextProvider } from './context/SocketContext.jsx';
// import { ColoniesProvider } from './context/ColoniesContext.jsx';
// import { TransactionTypeProvider } from './context/TransactionTypeContext.jsx';
// import { PropertyTypeProvider } from './context/PropertyTypeContext.jsx';
// import { SizesProvider } from './context/SizesContext.jsx';
import { NavigationLocationProvider } from './context/navigationContext.jsx';
// import { GeneralFeaturesProvider } from './context/GeneralFeaturesContext.jsx';
// import { UserTypeProvider } from './context/UserTypeContext.jsx';
// import { ClientTypeProvider } from './context/ClientTypeContext.jsx';
// import { PostContactTypeProvider } from './context/PostcontactTypeContext.jsx';
// import { MasterTagsReadyProvider } from './context/MasterTagsReadyContext.jsx';

import { ChatProvider } from './context/chatContext.jsx';
import SplashScreen from './components/splashscreen/splashscreen.jsx';
import { ToastProvider } from './components/showtoast/ToastContext.jsx';
import { MasterDataProvider } from './context/MasterDataContext.jsx';
import { MultiOrbitSpinner3 } from './lib/myIcons.jsx';
import { PropertyListProvider } from './context/PropertyListContext.jsx';
import MasterInitializer from './context/MasterInitializer.jsx';

// ------------------ Hydration Wrapper ------------------
const HydrationWrapper = ({ children }) => {

  const [showSpinner,setShowSpinner]=useState(true);
  const [showApp, setShowApp] = useState(false);
  const [showSplash, setShowSplash] = useState(false); // ⚡ this was missing
// const [isHydrated, setIsHydrated] = useState(false);

  // useEffect(() => {
  //   setIsHydrated(true);

  //   // remove splash screen (if exists)
  //         // const splash = document.getElementById('splash-screen');
  //         // if (splash) {
  //         //   splash.style.transition = 'opacity 0.5s';
  //         //   splash.style.opacity = 0;
  //         //   setTimeout(() => splash.remove(), 500);
  //         // }
  // }, []);


 // Step 1 → Show spinner for 1 second
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinner(false);
      setShowSplash(true);   // start splash screen next
    }, 1000);

    return () => clearTimeout(timer);
  }, []);


  // Step 2 → When splash ends → show the app
  // const handleSplashFinish = () => {
  //   setShowSplash(false);
  //   setAppReady(true);
  // };

if (showSpinner) return (
 <div
      style={{
        position: 'fixed',   // stay on top
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff', // optional: background while spinner shows
        zIndex: 9999,            // ensure it overlays everything
      }}
    >
      <MultiOrbitSpinner3 />
    </div>
);

  if (showSplash) return <SplashScreen onFinish={() => setShowSplash(false)} />;

  return (
    <>
      {children}  {/* App mounts immediately in the background */}
      {showSplash && <SplashScreen onFinish={() => setShowSplash(true)} />}

    </>
  );
};

// ------------------ Combined Providers ------------------
function AllProviders({ children }) {
  return (
    <AuthContextProvider>
      <ToastProvider position="bottom-center">
        <MasterDataProvider>

          <MasterInitializer/>
            {/* <ColoniesProvider> */}
            {/* <TransactionTypeProvider> */}
            {/* <PropertyTypeProvider> */}

            <NavigationLocationProvider>
              {/* <SizesProvider> */}
              {/* <GeneralFeaturesProvider> */}
              {/* <UserTypeProvider> */}
              {/* <ClientTypeProvider> */}
              {/* <PostContactTypeProvider> */}

              <PropertyListProvider>

                <ChatProvider>
                  {/* <SocketContextProvider> */}
                  {children}
                  {/* </SocketContextProvider> */}
                </ChatProvider>

              </PropertyListProvider>
              {/* </PostContactTypeProvider> */}
              {/* </ClientTypeProvider> */}
              {/* </UserTypeProvider> */}
              {/* </GeneralFeaturesProvider> */}
              {/* </SizesProvider> */}
            </NavigationLocationProvider>
            {/* </PropertyTypeProvider> */}
            {/* </TransactionTypeProvider> */}
            {/* </ColoniesProvider> */}

          {/* </MasterInitializer> */}

        </MasterDataProvider>
      </ToastProvider>
    </AuthContextProvider>
  );
}

// ------------------ Root Render ------------------
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <AllProviders>
        <HydrationWrapper>
          <App />
        </HydrationWrapper>
    </AllProviders>
  // </React.StrictMode>
);
